import { DadosEspacoDisco } from "@/contexts/home/components/DadosEspacoDisco/DadosEspacoDisco";
import { DadosSyncAutomatico } from "@/contexts/home/components/DadosSyncAutomatico/DadosSyncAutomatico";
import { DadosSyncMunicipio } from "@/contexts/home/components/DadosSyncMunicipio/DadosSyncMunicipio";
import { MenuCard } from "@/contexts/home/components/MenuCard/MenuCard";
import { useEffect } from "react";

export function Inicio() {
  useEffect(() => {
    document.title = "Inspeção Mobile - Início";
  }, []);

  return (
    <>
      <MenuCard />

      <DadosSyncMunicipio />

      <DadosSyncAutomatico />

      <DadosEspacoDisco />
    </>
  );
}
